import { useTranslation } from "react-i18next";
import styles from "../../Components/Bookings/Bookings.module.css";
import CheckOutItem from "../../Components/CheckOut/CheckOutItem";
import BillLine from "../../Components/Bookings/BillLine";
import couponImg from "../../Images/coupon-img.png";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getPaymentMethod,
  addPayment,
  paymentStatus,
} from "../../redux/Slices/payment/thunk";
import { getOneUser } from "../../redux/Slices/users/thunk";
import {
  reservationService,
  getCoupon,
  resetCopon,
  checkScheduleTime,
  getLoyalPoint,
} from "../../redux/Slices/reservation/thunk";
import { Modal, Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import notify from "../../Components/Utilities/notify";

export default function CheckOutPage() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const settings = useSelector((state) => state.usersSlice.settings);
  const paymentMethods = useSelector(
    (state) => state.paymentSlice.paymentMethods
  );
  const PaymentResponse = useSelector(
    (state) => state.paymentSlice.PaymentResponse
  );
  const copon = useSelector((state) => state.reservationSlice.copon);
  const oneUser = useSelector((state) => state.usersSlice.oneUser);
  const selectedCountry = JSON.parse(localStorage.getItem("selectedCountry"));

  const [payStatus, setPayStatus] = useState();
  const [coponValue, setCoponValue] = useState("");
  const [coponValueOnClick, setCoponValueOnClick] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [coponLoading, setCoponLoading] = useState(false);
  const [loyalPoint, setLoyalPoint] = useState(false);
  const [showPaymentMethodsModal, setShowPaymentMethodsModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();

  useEffect(() => {
    if (PaymentResponse != null && PaymentResponse?.IsSuccess) {
      const invoiceId = PaymentResponse?.Data?.InvoiceId;
      const PaymentURL = PaymentResponse?.Data?.PaymentURL;
      localStorage.setItem("PaymentURL", PaymentURL);
      localStorage.setItem("invoiceId", invoiceId);
      console.log("invoiceId111", invoiceId);

      if (invoiceId) {
        localStorage.setItem("invoiceId", invoiceId);
        const statusData = { key: invoiceId
        };
        //  isTest: true 
        dispatch(paymentStatus({ data: statusData }));
      }
      window.location.href = PaymentResponse?.Data?.PaymentURL;
    }
  }, [PaymentResponse]);

  useEffect(() => {
    dispatch(getPaymentMethod());
    dispatch(getOneUser(Carts[0]?.client_id));
    dispatch(getLoyalPoint({id:Carts[0]?.client_id}));
    return () => {
      dispatch(resetCopon());
    };
  }, []);

  console.log("settings", settings);
  if (!location.state) {
    navigate("/cart");
    return null;
  }

  const Carts = location.state?.Carts || [];

  const PriceIncludingTax = Carts?.reduce((sum, cart) => {
    const price = parseFloat(cart.itm_price?.trim()) || 0; // Ensure valid number
    return sum + price;
  }, 0);

  let pointPrice = 0;
  let taxPersentage = 0;
  if (settings) {
    pointPrice = Number(settings?.point_price);
    taxPersentage = Number(settings?.tax);
  }
  let tax = (
    PriceIncludingTax -
    (PriceIncludingTax * 100) / (100 + taxPersentage)
  ).toFixed(2);
  console.log("taxPersentage", taxPersentage);
  console.log("Carts", Carts);

  const onSubmitMethod = async (PaymentMethodId) => {
    let data 
    if(PaymentMethodId=='17'){
      let arrayData = Carts.map((item) => {
        return {
          ItemName: item?.itm_nam?.trim(),
          UnitPrice: item?.itm_price?.trim(),
        };
      })
      data = {
        // isTest: true,
        paymentMethodId: PaymentMethodId,
        displayCurrencyIso: "SAR",
        price: totalMoney,
        name: oneUser?.cln_RegName?.trim(),
        callBackUrl: "https://reservation.ladycaresa.com/HomePage",
        errorUrl: "https://reservation.ladycaresa.com/cart",
        customerReference: "",
        CustomerName: oneUser?.cln_RegName?.trim(),
        CustomerEmail: oneUser?.cln_email?.trim(),
        CustomerMobile: oneUser?.cln_mobl?.trim(),
        InvoiceItems:arrayData
      };
    } else{
      data = {
      //  isTest: true,
       paymentMethodId: PaymentMethodId,
       displayCurrencyIso: "SAR",
       price: totalMoney,
       name: oneUser?.cln_RegName?.trim(),
      countryCode: selectedCountry?.countryCode?.replace(/^\+/, ""),
       callBackUrl: "https://reservation.ladycaresa.com/HomePage",
       errorUrl: "https://reservation.ladycaresa.com/cart",
       customerReference: "",
     };

    }
    
    console.log("data online", data);
// return

    await dispatch(
      addPayment({
        id:user?.cln_key,
        data,
      })
    );
  };

  const itmSrlArray = Carts.map((item) => item?.itm_srl?.trim());
  const empNumArray = Carts.map((item) => item?.emp_num?.trim());
  const timeArray = Carts.map((item) => item?.time?.trim());
  const logInArray = Carts.map((item) => item?.log_in?.trim());
  const logOutArray = Carts.map((item) => item?.log_out?.trim());
  const dateArray = Carts.map((item) => item?.date?.trim());
  const minArray = Carts.map((item) => item?.service_min?.trim());

  const currentDate = new Date();
  const date = currentDate.toISOString().split("T")[0];

  console.log("date", date);
  const applyCopon = async () => {
    console.log("coponValue", coponValue);
    setCoponLoading(true);
    const action = await dispatch(getCoupon({ code: coponValue }));
    console.log("action", action);

    if (action.meta.requestStatus === "fulfilled") {
      notify(t("couponAddedSuccess"), "success");
    }
    setCoponLoading(false);
    setCoponValueOnClick(coponValue);
  };
  const onSubmit = async () => {
    try {
      console.log("isLoading", isLoading);
      console.log("payStatus", payStatus);
      setIsLoading(true);
      setOpenModal(false);
  
      let data = {
        branchId: Carts[0]?.brn_num,
        servicesDate: dateArray,
        servicesId: itmSrlArray,
        employeesId: empNumArray,
        serviceTime: timeArray,
        paymentWay: payStatus,
        moneyFromPayment: totalMoney,
        paymentUnitsPrice: loyalPoint ? 3 : 0,
        moneyFromUnitsPrice: loyalPoint ? LoyalPointValue : 0,
        clientId: Carts[0]?.client_id,
        discount: (copon?.copd_desn) * 100,
        discountValue: discountByMoney,
        date: date,
        copon: coponValueOnClick,
        serviceMin: minArray,
        logIn: logInArray,
        logOut: logOutArray
      };
  // return console.log("datadatadata",data)
      let dataForCheck = {
        servicesId: itmSrlArray,
        employeesId: empNumArray,
        serviceTime: timeArray,
        servicesDate: dateArray,
        serviceMin: minArray
      };
  
      if (!payStatus) {
        setIsLoading(false);
        return notify(t("pleaseChoosePaymentMethod"), "error");
      }
  
      let checkResponce = await dispatch(checkScheduleTime({ data: dataForCheck }));
      
      if (checkResponce?.meta?.rejectedWithValue) {
        setIsLoading(false);
        return;
      }
  
      if (payStatus) {
        // Online
        if (payStatus == 2) {
          localStorage.setItem("reservationData", JSON.stringify(data));
          setOpenModal(false);
          setShowPaymentMethodsModal(true);
          setIsLoading(false);
        }
        // Cash
        else {
          setOpenModal(false);
          await dispatch(reservationService({ data }));
          notify(t("reservationSuccess"), "success");
          setIsLoading(false);
          navigate("/HomePage");
        }
      }
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };
    console.log("isLoading", isLoading);


  // ------------------------------

  let discountByMoney = 0;
  if (copon?.copd_desn) {
    if (copon?.copd_desn * PriceIncludingTax > copon?.copd_desval) {
      discountByMoney = copon?.copd_desval;
    } else {
      discountByMoney = copon?.copd_desn * PriceIncludingTax;
    }
  }
  console.log("openModal", openModal);

  let LoyalPointValue = 0;
  if (loyalPoint) {
    if (
      oneUser?.cln_units * pointPrice <=
      PriceIncludingTax - discountByMoney
    ) {
      LoyalPointValue = oneUser?.cln_units * pointPrice;
    } else {
      LoyalPointValue = PriceIncludingTax - discountByMoney;
    }
  }

  let totalMoney = PriceIncludingTax - discountByMoney - LoyalPointValue;

  return (
    <div className="container flex-grow-1">
      <div className={styles.loginContainer}>
        <div className={`${styles.loginHeader} my-3`}>
          
       { payStatus == 1 ? t("complete_reservation") : t("complete_payment") }
        </div>
        {Carts && <CheckOutItem Carts={Carts} />}

        <div
          className={`d-flex justify-content-between flex-wrap mx-auto ${styles.togelWidth}`}
        >
          <div
            className={`${styles?.checkOutPaymentBox} d-flex flex-column flex-wrap`}
          >
            <div className={`${styles.box2} p-2 w-100`}>
              <div className={`${styles.titleBill} my-1  ${styles.txt_start}`}>
                {" "}
                {t("paymentType")}{" "}
              </div>
             {settings?.cash_visible && <div className="my-auto d-flex flex-row">
                <input
                  type="radio"
                  id="cash"
                  className={`mx-3`}
                  onChange={(e) => setPayStatus(e.target.value)}
                  value="1"
                  name="paymentType"
                  style={{ borderRadius: "50% !important" }}
                  checked={payStatus == 1}
                />
                <label
                  htmlFor="cash"
                  className={`${styles?.checkOutFont}  ${styles.smallFont}`}
                >
                  {t("cash")}
                </label>
              </div>}

              <div className="d-flex flex-row">
                <input
                  type="radio"
                  id="online"
                  className="mx-3"
                  onChange={(e) => setPayStatus(e.target.value)}
                  value="2"
                  name="paymentType"
                  checked={payStatus == 2}
                />
                <label
                  htmlFor="online"
                  className={`${styles?.checkOutFont} ${styles.smallFont}`}
                >
                  {t("online")}
                </label>
              </div>
            </div>

            <div className={`${styles.box2} p-2  w-100 my-2`}>
              <div className={`${styles.titleBill} my-2 ${styles.txt_start}`}>
                {" "}
                {t("Discount Coupon")}{" "}
              </div>
              <div className="mx-auto" style={{ position: "relative" }}>
                <input
                  className={`${styles?.coupon_input}  ${styles.smallFont} py-3`}
                  type="text"
                  placeholder={t("Discount Coupon")}
                  onChange={(e) => setCoponValue(e.target.value)}
                />
                <img
                  src={couponImg}
                  className={`${styles?.coupon_img}`}
                  style={{ marginTop: "-2px" }}
                />
                <div
                  className={`${styles?.couponbtn} ${
                    coponLoading || coponValue === "" ? styles?.disabled : ""
                  }`}
                  onClick={
                    !coponLoading && coponValue !== "" ? applyCopon : null
                  }
                >
                  {coponLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    t("apply")
                  )}
                </div>
              </div>
            </div>

            <div className={`${styles.box2} p-2  w-100 my-2`}>
              <div className={`${styles.titleBill} my-2 ${styles.txt_start}`}>
                {" "}
                {t("Loyal Points")}{" "}
              </div>

              <div className="d-flex">
                <input
                  type="checkbox"
                  id="LoyalPoint"
                  className="mx-3"
                  onChange={(e) => setLoyalPoint(e.target.checked)}
                  name="paymentType"
                  checked={loyalPoint == true}
                  style={{ width: "20px", accentColor: "#B49345" }}
                />
                <div> {t("Loyal Points")} </div>
                <div style={{ margin: "0 8px" }}>
                  {oneUser?.cln_units == null ? 0 :Number(oneUser?.cln_units)?.toFixed(2)}
                </div>
              </div>
              {/* <div className='mx-auto' style={{position:'relative'}}>
                  <input className={`${styles?.coupon_input} py-3`} type='text' placeholder={t("Loyal Points")}  />
                  <img src={couponImg} className={`${styles?.coupon_img}`} />
                </div> */}
            </div>
          </div>

          <div
            className={`${styles.box2} w-50 p-2`}
            style={{ marginBottom: "7px" }}
          >
            <div className={`${styles.titleBill}`}>{t("Bill")} </div>

            <BillLine
              text1={t("totalIncludingTax")}
              text2={`${PriceIncludingTax.toFixed(2)} ${t("rs")}`}
              styles={styles}
              myClass="my-3 justify-content-between"
            />
            <BillLine
              text1={t("Added Value Tax")}
              text2={`${tax} ${t("rs")}`}
              styles={styles}
              myClass="my-3 justify-content-between"
            />
            <BillLine
              text1={t("Discount Coupon")}
              text2={`${Number(discountByMoney)?.toFixed(2)} ${t("rs")}`}
              styles={styles}
              myClass="my-3 justify-content-between"
            />
            <BillLine
              text1={t("Loyal Points")}
              text2={`${Number(LoyalPointValue).toFixed(2)} ${t("rs")}`}
              styles={styles}
              myClass="my-3 justify-content-between"
            />
            <BillLine
              text1={t("Total")}
              text2={`${totalMoney.toFixed(2)} ${t("rs")}`}
              styles={styles}
              type="total"
              myClass="my-3 justify-content-between"
            />
          </div>
        </div>
        <div
          className={`${styles.submitContainer} ${styles.submitContainerMaxWidth}`}
          style={{ margin: "0 auto 15px auto", maxWidth: "972px" }}
        >
          {isLoading ? <div className={`${styles.onSubmit} w-100`} > <Spinner /></div> :<div
            className={`${styles.onSubmit} w-100`}
            disabled={isLoading}
            onClick={()=>{
              if(!payStatus) return notify((t("pleaseChoosePaymentMethod")),"error")
              setOpenModal(true)
            }}
          >
            { payStatus == 1 ? t("complete_reservation") : t("complete_payment")}
          </div>}
        </div>
      </div>

      {showPaymentMethodsModal && (
        <Modal
          show={showPaymentMethodsModal}
          onHide={() => setShowPaymentMethodsModal(false)}
        >
          <Modal.Body>
            <h5 className="h5ModalTitle">طريقة الدفع</h5>
            <div
              className="label"
              style={{ display: "flex", justifyContent: "center" }}
            >
              من فضلك قم باختيار طريقة الدفع
            </div>

            <div className="payment-methods mt-3">
              {paymentMethods?.Data?.PaymentMethods?.length > 0 ? (
                paymentMethods.Data.PaymentMethods.map((method) => (
                  <div
                    key={method.PaymentMethodId}
                    className="payment-method-item"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      marginBottom: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      onSubmitMethod(method.PaymentMethodId);
                      console.log(
                        "Selected Payment Method:",
                        method.PaymentMethodAr
                      );
                      setSelectedMethod(method);
                    }}
                  >
                    <span>{method.PaymentMethodAr}</span>
                    <span>{method.PaymentMethodEn}</span>
                    <img
                      src={method.ImageUrl}
                      alt={method.PaymentMethodEn}
                      style={{ width: "50px", height: "auto" }}
                    />
                  </div>
                ))
              ) : (
                <div className="text-center">لا توجد طرق دفع متاحة حالياً</div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center border-0">
            <Button
              onClick={() => {
                setShowPaymentMethodsModal(false);
              }}
              className="w-25"
              variant="primary"
              style={{ backgroundColor: "#F0142F", border: "#F0142F" }}
            >
              إلغاء
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {openModal && (
        <Modal
          show={openModal}
          onHide={() => setOpenModal(false)}
        >
          <Modal.Body>
            <h5 className="h5ModalTitle">{t('confirmreservationServices')}</h5>

          
            

             {isLoading ? <Spinner /> : <div className={styles.onSubmit} onClick={onSubmit} disabled={isLoading} style={{height:"50px"}} >
              {  payStatus == 1 ? t("complete_reservation") : t("complete_payment") }
              </div>}
          </Modal.Body>
      
        </Modal>
      )}



    </div>
  );
}
